export const OTHER_SHELVES = '*'

export type ShelfSelection = {
  keys: string[]
  excludeFromOthers?: string[]
}

export const bookShelfKey = (name: string): string =>
  name
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 57)

export const applySelection = <T>(
  items: T[],
  keyOf: (item: T) => string,
  selection?: ShelfSelection
): T[] => {
  if (!selection) {
    return items
  }

  const byKey = new Map(items.map(item => [keyOf(item), item]))
  const excluded = new Set([
    ...(selection.excludeFromOthers ?? []),
    ...selection.keys
  ])

  return selection.keys.flatMap(key => {
    if (key === OTHER_SHELVES) {
      return items.filter(item => !excluded.has(keyOf(item)))
    }
    const item = byKey.get(key)
    return item ? [item] : []
  })
}
